import { useContext, useState } from "react";
import { AuthContext } from "../../../../../../context/context";
import { endoso } from "../../../../../../services";
import { EndosoContext } from "../../../../context";

export const usePagination = ({ holders, setMessage }) => {
  const { setTimer, persons, setPersons } = useContext(AuthContext);
  const {
    bajaRiesgo15,
    setBajaRiesgo15,
    formDta,
    searchWord,
    selected,
    setSelected,
  } = useContext(EndosoContext);
  const [loader, setLoader] = useState(false);
  const [page, setPage] = useState(1);

  const getPage = (page) => {
    setTimer(0);
    setLoader(true);
    const body = {
      pagina: page + 1,
      solicitud: formDta.noSolicitud,
      nivel: formDta.nivel,
      clave: searchWord || null,
    };
    endoso.nivel902(body).then(({ data }) => {
      if (data) {
        setBajaRiesgo15({
          ...bajaRiesgo15,
          initialData: data,
          niveles: data.niveles,
        });
        setPage(page + 1);
        setLoader(false);
      }
    });
  };
  const handleChangePagination = ({ row }) => {
    setTimer(0);
    if (row.checked) {
      const removeRow = selected.filter((item) => item.codigo !== row.codigo);
      setSelected(removeRow);
      setPersons(removeRow.map((item) => item.codigo));
      const newRows = bajaRiesgo15.niveles.map((nivelRow) =>
        nivelRow.codigo === row.codigo
          ? { ...nivelRow, checked: false }
          : nivelRow
      );
      setBajaRiesgo15({
        ...bajaRiesgo15,
        niveles: newRows,
      });
    } else {
      if (selected.length >= 10) return;

      const newSelected = [...selected, row];
      const filterSelected =
        newSelected?.filter((select) => Number(select.codigo) % 10 === 0) || [];
      if (holders && holders - filterSelected?.length < 10) {
        if (setMessage) {
          setMessage({
            text: "El movimiento solicitado no puede ejecutarse debido a que no cumple con el mínimo de asegurados activos para este producto",
            severity: "warning",
          });
        }
        return;
      }
      setSelected(newSelected);
      setPersons([...persons, row.codigo]);
      const newRows = bajaRiesgo15.niveles.map((nivelRow) =>
        nivelRow.codigo === row.codigo
          ? { ...nivelRow, checked: true }
          : nivelRow
      );
      setBajaRiesgo15({
        ...bajaRiesgo15,
        niveles: newRows,
      });
    }
  };

  return {
    setLoader,
    loader,
    page,
    getPage,
    handleChangePagination,
    selected,
  };
};
